<style lang="scss">
.booking-slot-stats-day-blocks {
  &__days{
    .slot-card {
      border: 2px solid #7B2DA4;
      border-radius: 10px;
      overflow: hidden;

      &__name{
        color: white;
        height: 85px;
      }

      b{
        width: 100%;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>

<template>
  <section class="booking-slot-stats-day-blocks">
    <p class="brand-color font-weight-bold text-capitalize mt-2 mb-4">{{activeDay}} Slot Utilization rate: {{slotHelpers.calculateTotalUtilizationForSlots(daySlotData)}}</p>

    <section class="booking-slot-stats-day-blocks__days d-flex flex-wrap">
      <div class="col-4" :key="slot.booking_slot_id" v-for="slot in daySlotData">
        <section class="slot-card">
          <p class="slot-card__name d-flex justify-content-center align-items-center text-center purple-background font-weight-bold mb-0 p-2">{{slot.name}}</p>
          <section class="p-2">
            <p class="d-flex flex-wrap justify-content-center mb-0">Total Bookings: <b>{{slot.bookings}}</b></p>
            <p class="d-flex flex-wrap justify-content-center mb-0">Total Possible Bookings: <b>{{slot.total_possible_bookings}}</b></p>
            <p class="d-flex flex-wrap justify-content-center mb-0">Utilization rate:
              <b>{{slotHelpers.calculateUtilizationRate(slot.total_possible_bookings, slot.bookings)}}</b>
            </p>
          </section>
        </section>
      </div>
    </section>
  </section>
</template>

<script>
  import BookingSlotCalculations from './BookingSlotCalculations';
  export default {
    props: {
      activeDay: {
        required: true,
        type: String,
      },
      daySlotData: {
        required: true,
        type: Array,
      }
    },
    components: {},
    data() {
      return {
        slotHelpers: new BookingSlotCalculations(),
      };
    },
    mounted() {

    },
    methods: {

    },
  };
</script>
